import classNames from 'classnames';
import './Separator.scss';

type SeparatorProps = React.HTMLAttributes<HTMLHRElement>;

export const Separator: React.FC<SeparatorProps> = ({ className, ...props }) => (
	<hr {...props} className={classNames('separator', className)} />
);
